import script from "./VideoEditorMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoEditorMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./VideoEditorMolecule.vue?vue&type=style&index=0&id=4624c2bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4624c2bc"]])

export default __exports__